import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      token: null,
      user: null,

      setAuth: (token, user) => set({ token, user }),

      logout: () => {
        set({ token: null, user: null });
      },

      isAuthenticated: () => !!get().token,

      // Capabilities in the open workspace, as resolved by the server — see
      // backend/src/lib/access.js. Components can use the useCan hook instead.
      can: (capability) => !!get().user?.capabilities?.includes(capability),

      // An owner or admin of the account that owns the open workspace.
      isAdmin: () => !!get().user?.capabilities?.includes('org:manage'),

      isSuperadmin: () => !!get().user?.is_superadmin,

      // The account's plan state. Only set for its members — a guest is not shown
      // the host's billing.
      getOrg: () => get().user?.organisation,

      getSubscriptionStatus: () => {
        const org = get().user?.organisation;
        if (!org) return null;
        if (org.subscription_status === 'trial') {
          if (org.trial_ends_at && new Date() > new Date(org.trial_ends_at)) {
            return 'trial_expired';
          }
          return 'trial';
        }
        return org.subscription_status;
      },

      getTrialDaysRemaining: () => {
        const org = get().user?.organisation;
        if (!org || org.subscription_status !== 'trial' || !org.trial_ends_at) return null;
        const ms = new Date(org.trial_ends_at) - new Date();
        if (ms <= 0) return 0;
        return Math.ceil(ms / (1000 * 60 * 60 * 24));
      },
    }),
    {
      name: 'mission-control-auth',
      partialize: (state) => ({ token: state.token, user: state.user }),
    }
  )
);
